import { DialogContent, DialogContentText } from "@material-ui/core";
import React from "react";
import { DialogContentErrorText, DialogContentSuccessText } from "../../../../functions/errorHandling";
import IAPI from "../../../../models/IAPI";
import IIntegration from "../../../../models/IIntegration";
import { IntegrationStatuses } from "../../IntegrationStatuses";
import IntegrationAPISelectTable from "../../sections/apis/IntegrationAPISelectTable";

interface ISelectAPIsDialogContentProps {
  token: string;
  integration: IIntegration;
  selectedAPIs: IAPI[];
  setSelectedAPIs: (apis: IAPI[]) => void;
  apiSCNumber: string;
  apiUpdateSubmitErrors: string[];
}

export const SelectAPIsDialogContent = (props: ISelectAPIsDialogContentProps) => {
  const { token, integration, selectedAPIs, setSelectedAPIs, apiSCNumber, apiUpdateSubmitErrors } = props;

  const hasErrors = (): boolean => {
    if (apiUpdateSubmitErrors.length === 0 || (apiUpdateSubmitErrors.length === 1 && apiUpdateSubmitErrors[0] === "")) {
      return false;
    }

    return true;
  };

  return (
    <>
      {(!apiSCNumber || apiSCNumber == "") && !hasErrors() && (
        <DialogContent>
          <DialogContentText>Choose the APIs that will be used by this Integration.</DialogContentText>
          {integration.Status.ID == IntegrationStatuses.AvailableForCustomers && (
            <DialogContentText>A service call will be submitted and reviewed. When approved, APIs will be shown on the details screen.</DialogContentText>
          )}
          <IntegrationAPISelectTable token={token} integration={integration} name="APIs Used" selectedAPIs={selectedAPIs} setSelectedAPIs={setSelectedAPIs} />
        </DialogContent>
      )}
      {apiSCNumber && !hasErrors() && (
        <DialogContent>
          <DialogContentSuccessText>Ticket # {apiSCNumber}</DialogContentSuccessText>
          <DialogContentText>
            Our staff will review your integration update as soon as they can. Use the ticket number above when contacting us regarding this update.
          </DialogContentText>
        </DialogContent>
      )}
      {hasErrors() && (
        <DialogContent>
          <DialogContentErrorText>
            An error was encountered submitting your API update request. Please submit a service ticket to us referencing the following information.
          </DialogContentErrorText>
          {apiUpdateSubmitErrors.map(err => {
            return <DialogContentErrorText>{err}</DialogContentErrorText>;
          })}
        </DialogContent>
      )}
    </>
  );
};
